<template>
  <div class="page-content mail-content">
    <div class="mt-4 ml-4 mb-0">
      <button class="btn btn-default btn-border no-border" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i>
        {{ $t('go_back') }}
      </button>
    </div>
    <div class="email-head d-lg-flex d-block">
      <h3>{{ message.subject }}  <span class="badge" :class="$route.query.general ? 'badge-warning' : 'badge-secondary'">{{ getCategory(message) }}</span></h3>
    </div>
    <div class="email-sender">
      <div class="avatar">
        <img :src="message.author ? (message.author.profile_image_small || message.author.profile_image || defaultImage) : defaultImage" alt="..." onerror="this.src = '/static/img/img-placeholder.jpg'">
      </div>
      <div class="sender">
        <b>{{ $t('author') }}</b> <span class="text-primary"><b>{{ message.author.full_name }}</b></span>
      </div>
      <div class="date">{{ moment(message.createdAt).format('LLL') }}</div>
    </div>
    <div class="email-body" v-html="message.content"></div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Message from '../services/messages'

export default {
  name: 'MessagesDetail',
  data: function () {
    return {
      moment: moment,
      message: {
        subject: '',
        content: '',
        author: {
          full_name: ''
        },
        createdAt: ''
      },
      defaultImage: '/static/img/img-placeholder.jpg',
      categories: [
        { id: 0, name: 'Dashboard' },
        { id: 1, name: this.$t('distribution') },
        { id: 2, name: this.$t('bank') },
        { id: 3, name: this.$t('subscription') },
        { id: 4, name: this.$t('claims') }
      ]
    }
  },
  methods: {
    getCategory: function (message) {
      return message.subject ? _.filter(this.categories, elem => elem.id === message.type)[0].name : ''
    }
  },
  created: function () {
    if (this.$route.query.general) {
      Message.getGeneral(this.$route.params.id).then(response => {
        if (response.data) {
          this.message = response.data
          this.message.author.full_name = ((obj) => {
            let n = ''
            if (obj.name) {
              n = obj.name + ' ' + (obj.last_name || '')
            } else if (obj.email) {
              n = obj.email
            } else {
              n = obj.username
            }
            return n
          })(this.message.author)
        }
      })
    } else {
      Message.get(this.$route.params.id).then(response => {
        if (response.data) {
          this.message = response.data
          this.message.author = this.message.author || {}
          this.message.author.full_name = ((obj) => {
            let n = ''
            if (obj.name) {
              n = obj.name + ' ' + (obj.last_name || '')
            } else if (obj.email) {
              n = obj.email
            } else {
              n = obj.username
            }
            return n
          })(this.message.author)
          this.$eventBus.$emit('getTotalsUnreadMessages')
        }
      })
    }
  },
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/MessagesDetail.vue